module.exports = __webpack_public_path__ + "static/media/short_bow.e3ed59af.png";